import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { HTTP_VERBS, requestHttp } from "../../../../utils/HttpRequest";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export const PropertyGrafBarChartAniomes = (item) => {
  const [ precipitationaniomes, setPrecipitationaniomes ] = useState([]);
  //console.log({item: item})             

  //anio       
  useEffect(() => {
    const getData = async ()=>{
        try {                                                    
          item.anio ? getPrecipitationaniomes():console.log('');            
        } catch (error) {
            console.log(error)
        }             
    }    
    getData();         
        
  },[item.anio])
  //getPrecipitation
  const getPrecipitationaniomes = async ()=>{                
    try {                      
        const response = await requestHttp(
            {
                method: HTTP_VERBS.GET,
                endpoint: '/precipitations/aniomes',                         
                params: makePropertiesFiltersanio()                                     
            }
        );             
        const {data} = response;                
        setPrecipitationaniomes(data);    
        //console.log({dataAniomes: data})  
            
    } catch (error) {
        if(error.response.status === 401){
          console.log('')
        }else{
            console.log(error)
        }
    }    
  }
  const makePropertiesFiltersanio = ()=>{
      const filters = {};                                           
          filters['anio'] = item.anio?item.anio:console.log('');               
          filters['mes'] = item.mes?item.mes:console.log('');   
          filters['tipo']= 'Grafico'
          //console.log({filters: filters})            
      return filters;       
  }

  const generateChartData = () => {
    const uniqueFincas = [...new Set(precipitationaniomes.map((itemPrec) => itemPrec.Finca))];
    const uniqueMes = [...new Set(precipitationaniomes.map((itemPrec) => itemPrec.mes))];    
    //console.log({Mes: uniqueMes})  
    //console.log({fincas: uniqueFincas})
    const datasets = uniqueMes.map((mes) => {
      const dataForMes = uniqueFincas.map((finca) => {
        const matchingData = precipitationaniomes.find(
          (data) => data.Finca === finca && data.mes === mes
        );
        return matchingData ? matchingData.totalLLuvia: 0;
      });

      return {
        label: `Mes ${mes}`,
        data: dataForMes,
        backgroundColor: `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.2)`,
        borderColor: ["#blue"],
        borderWidth: 1,
      };
    });

    return { labels: uniqueFincas, datasets };
  };
  
  const chartData = generateChartData();

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Precipitación (mm)',
        },
      },
    },
  };
  

  /*
  const data = {
    labels: sem,
    datasets:[{
       label: "mm", 
       data: precipitacion, 
       tension: 0.2,
       borderColor: "blue",
       borderWidth: 2,
       fill: true,
       backgroundColor: 'blue'       
    }],
  };

  const options = {
    maintainAspectRatio:false,
    responsive: true,

    plugins:{
      legend:{
        display: false,
        position: 'top',
      },
    },
  */
    /*scales:{
      y:{
        min: 0,
      },
    },

    plugins:{
      legend:{
        display: true,
        position: 'top',
      },
    },
    tooltip:{
      intersect: false,
      mode: 'index',
      callbacks:{
        label: function (context){
          const label = context.dataset.label || '';
          const value = context.formattedValue;
          return `${label}: ${value} mm`
        },
      },
    },  */
  
  //<Bar data={chartData} options={options} />
  return (
    <div>
     <h2>Gráfico de Precipitación de Fincas Ultimos 3 Meses del año</h2>
     <Bar data={chartData} options={options} />
    </div>
  )
}


